export const buildCaCpaRoutingNumber = (
  institutionNumber: string,
  transitNumber: string,
): string => `0${institutionNumber}${transitNumber}`;

export const normalizeRoutingNumber = (routingNumber: string): string => {
  // Remove spaces, hyphens, and convert to uppercase
  const cleaned = routingNumber.replace(/[-\s]/g, "").toUpperCase();

  // Ensure it has a leading zero if it's 8 digits (institution + transit without leading 0)
  // CA CPA routing numbers should be 9 digits: 0 + 3-digit institution + 5-digit transit
  if (cleaned.length === 8 && /^\d{8}$/.test(cleaned)) {
    return `0${cleaned}`;
  }

  return cleaned;
};
